<template>
  <div :class="elem.classes" :style="elem.styles">
    <b-dropdown
      :class="elemDropdown.classes"
      :toggle-class="elemToggle.classes"
      ref="dropdown"
      variant="light"
      v-bind="elemDropdown.bindMore"
      :readonly="elemDropdown.readonly"
      :disabled="elemDropdown.disabled"
      :boundary="elemDropdown.boundary"
      @show="onDropdownShow"
    >
      <!-- Button -->
      <template #button-content>
        <span :class="elemSelected.classes" :title="elemSelected.title" v-html="elemSelected.content"></span>
      </template>
      
      <!-- Options -->
      <div class="dropdown-menu-inner">
        <perfect-scrollbar ref="scrollbar">
          <!-- Options Nested -->
          <div v-for="(option1,index) in options" :key="`lv1_${option1[_optionValue]}_${index}`">
            <!-- <b-dropdown-divider v-if="option1.id === 'custom'" class="bg-gray-light"/>  -->
            <div v-if="option1.id === 'custom'" class="dropdown-divider"/>
            <b-dropdown-item 
              :link-class="elemOptionClasses('1')" 
              :active="isActive(genValueFull(option1))"
              :disabled="isDisabled(genValueFull(option1))"
              @click="onChangeSelected(genValueFull(option1))"
            >
              <div class="dropdown-item-label" :style="option1[_optionStyle]" v-html="renderOptionContent(genValueFull(option1))" :title="option1[_optionLabel]" />
            </b-dropdown-item>
            
            <div v-for="(option2,index) in (option1.children || option1.child)" :key="`lv2_${option2[_optionValue]}_${index}`">
              <b-dropdown-item 
                :link-class="elemOptionClasses('2')" 
                :active="isActive(genValueFull(option1, option2))"
                :disabled="isDisabled(genValueFull(option1, option2))"
                @click="onChangeSelected(genValueFull(option1, option2))"
              >
                <div class="dropdown-item-label" :style="option2[_optionStyle]" v-html="renderOptionContent(genValueFull(option1, option2))" :title="option2[_optionLabel]" />
              </b-dropdown-item>
              
              <div v-for="(option3,index) in (option2.children || option2.child)" :key="`lv3_${option3[_optionValue]}_${index}`">
                <b-dropdown-item 
                  :link-class="elemOptionClasses('3')" 
                  :active="isActive(genValueFull(option1, option2, option3))"
                  :disabled="isDisabled(genValueFull(option1, option2, option3))"
                  @click="onChangeSelected(genValueFull(option1, option2, option3))"
                >
                  <div class="dropdown-item-label" :style="option3[_optionStyle]" v-html="renderOptionContent(genValueFull(option1, option2, option3))" :title="option3[_optionLabel]" />
                </b-dropdown-item>
                
                <div v-for="(option4,index) in (option3.children || option3.child)" :key="`lv4_${option4[_optionValue]}_${index}`">
                  <b-dropdown-item 
                    :link-class="elemOptionClasses('4')" 
                    :active="isActive(genValueFull(option1, option2, option3, option4))"
                    :disabled="isDisabled(genValueFull(option1, option2, option3, option4))"
                    @click="onChangeSelected(genValueFull(option1, option2, option3, option4))"
                  >
                    <div class="dropdown-item-label" :style="option4[_optionStyle]" v-html="renderOptionContent(genValueFull(option1, option2, option3, option4))" :title="option4[_optionLabel]" />
                  </b-dropdown-item>
                </div>

              </div>
            </div>
          </div>

          <!-- Options Empty -->
          <b-dropdown-text v-if="isEmpty">
            <div class="dropdown-item-label" :title="$t('engine.common.treeselect.empty', language)">{{ $t("engine.common.treeselect.empty", language) }}</div>
          </b-dropdown-text>

        </perfect-scrollbar>
      </div>

    </b-dropdown>
  </div>
</template>

<script>
import _ from 'lodash';
import { PerfectScrollbar } from "vue2-perfect-scrollbar";

export default {
  components: {
    PerfectScrollbar,
  },
  props: {
    /**
     * Value that selected
     */
    selected: {
      type: [Object, String],
      required: true,
    },

    /**
     * List of option 
     */
    options: {
      type: Array,
      required: true,
      default: () => [],
    },

    /**
     * List of option's value that are disabled
     */
    optionsDisabled: {
      type: Array,
      default: () => [],
    },

    /**
     * Key of option's value
     * Ex. 'value', 'id'
     */
    optionValue: {
      type: String,
      default: undefined,
    },

    /**
     * Key of option's label
     * Ex. 'label', 'text'
     */
    optionLabel: {
      type: String,
      default: undefined,
    },

    /**
     * Key of option's style
     * Ex. 'label', 'text'
     */
    optionStyle: {
      type: [String, Object],
      default: undefined,
    },

    /**
     * Key of option's icon
     * Ex. 'icon'
     */
    optionIcon: {
      type: String,
      default: undefined,
    },

    /**
     * Key of option's disabled
     * Ex. 'disabled'
     */
    optionDisabled: {
      type: String,
      default: undefined,
    },

    /**
     * ???
     */
    matchDisabledChange: {
      type: [Object, String],
      default: undefined,
    },

    /**
     * ???
     */
    matchDisabledDefault: {
      type: [Object, String],
      default: undefined,
    },

    /**
     * If selected doesn't appear in options, this value will be used for default and change selected
     */
    notMatchChange: {
      type: [Object, String],
      default: undefined,
    },

    /**
     * If selected doesn't appear in options, this value will be used for default but not change selected
     */
    notMatchDefault: {
      type: [Object, String],
      default: undefined,
    },

    /**
     * If selected doesn't appear in options, this text will be shown on toggle
     */
    notMatchText: {
      type: String,
      default: undefined,
    },

    /**
     * Advance for append more content of option's label
     */
    conditions: {
      type: Array,
      default: () => [],
    },

    /**
     * Positions to display more content for all option
     * Acceptable values:
     *   - true - Positions are option and selected
     *   - 'option' - Position is option only
     *   - 'selected' - Position is selected only
     */
    moreContentShow: {
      type: [Boolean, String, Array],
      default: true,
    },

    /**
     * Tool is readonly
     */
    readonly: {
      type: Boolean,
      default: false,
    },

    /**
     * Tool is disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * Tool's width is full of parent
     */
    block: {
      type: Boolean,
      default: true,
    },

    /**
     * Tool's boundary
     * That is Boostrap Dropdown's boundary
     */
    boundary: {
      type: String,
      default: undefined,
    },

    /**
     * Toggle's alignment
     * Acceptable values:
     *   - 'left'
     *   - 'center'
     *   - 'right'
     */
    textAlign: {
      type: String,
      default: 'left',
    },

    /**
     * Toggle's padding left-right
     * Acceptable values:
     *   - 'default'
     *   - 'small'
     */
    paddingSize: {
      type: String,
      default: "default", // padding size => default, small
    },

    /**
     * Menu's drop
     * That is Boostrap Dropdown's drop
     */
    menuDrop: {
      type: String,
      default: undefined,
      validator(value) {
        return ['left', 'right', 'dropright', 'dropleft'].includes(value);
      },
    },

    /**
     * Menu's max width
     */
    menuMaxWidth: {
      type: String,
      default: undefined,
    },

    /**
     * Menu's max height
     */
    menuMaxHeight: {
      type: String,
      default: undefined,
    },

    /**
     * Positions to display option's icon
     * Acceptable values:
     *   - true - Positions are option and selected
     *   - 'option' - Position is option only
     *   - 'selected' - Position is selected only
     */
    iconShow: {
      type: [Boolean, String, Array],
      default: false,
    },

    /**
     * Unit's content
     * That will append of option's label only
     * Ex. 'px'
     */
    unit: {
      type: String,
      default: undefined,
    },

    /**
     * Positions to display unit for all option
     * Acceptable values:
     *   - true - Positions are option and selected
     *   - 'option' - Position is option only
     *   - 'selected' - Position is selected only
     */
    unitShow: {
      type: [Boolean, String, Array],
      default: true,
    },

    /**
     * Language that use for tool's label
     * That will be used with engine label
     * Acceptable values:
     *   - 'en'
     *   - 'id'
     *   - 'th'
     */
    language: {
      type: String,
      default: 'en',
    }
  },
  data() {
    return {
      rootOptions: {},
      default: {
        menuDrop: undefined,
        menuMaxWidth: undefined, // unset
        menuMaxHeight: undefined, // 70vh
      },
      isSidebarArea: undefined, // ex. if dropdown in sidebar will force dropdown-menu to right
    };
  },
  computed: {
    // Dom
    elem() {
      return { 
        classes: {
          'mwe-treeselect': true,
          'position-relative': true,
        }, 
         styles: {
          '--menu-max-width': this.menuMaxWidth || this.default.menuMaxWidth,
          '--menu-max-height': this.menuMaxHeight || this.default.menuMaxHeight,
        }
      };
    },
    elemDropdown() {
      return { 
        classes: {
          'dropdown-select': true,
          'dropdown-select-px-sm': Boolean(this.paddingSize == 'small'),
          'dropdown-select-block': this.block,
        },
        bindMore: {
          [this._menuDrop]: Boolean(this._menuDrop),
        },
        readonly: this.readonly,
        disabled: this.disabled,
        boundary: this.boundary,
      };
    },
    elemToggle() {
      return { 
        classes: {
          [`text-${this.textAlign}`]: true,
        } 
      };
    },
    elemSelected() {
      return { 
        classes: {
          'selected': true,
        }, 
        content: this.renderSelectedContent(), 
        title: this.renderSelectedTitle(),
      };
    },

    // Root (Overwrite props)
    _optionsDisabled() {
      return this.optionsDisabled.map((valueFullObject) => this.convertValueToString(valueFullObject)); // [{}, ...] => [a-b-c-d, ...]
    },
    _selected() {
      let _selected = this.convertValueToString(this.selected);
      return _selected;
    },
    _matchDisabledChange() {
      if (this.matchDisabledChange === undefined) return this.matchDisabledChange;
      return this.convertValueToString(this.matchDisabledChange);
    },
    _notMatchChange() {
      if (this.notMatchChange === undefined) return this.notMatchChange;
      return this.convertValueToString(this.notMatchChange);
    },
    _notMatchDefault() {
      if (this.notMatchDefault === undefined) return this.notMatchDefault;
      return this.convertValueToString(this.notMatchDefault);
    },
    _notMatchText() {
      if (this.notMatchText !== undefined && this.notMatchText !== null) return this.notMatchText;
      return this.$t("engine.common.treeselect.choose", this.language);
    },
    _optionValue() {
      return this.optionValue || 'value';
    },
    _optionLabel() {
      return this.optionLabel || 'label';
    },
    _optionStyle() {
      return this.optionStyle || 'style';
    },
    _optionDisabled() {
      return this.optionDisabled || 'disabled';
    },
    _iconShow() {
      let iconShow = [];
      if (typeof this.iconShow === "boolean") iconShow = this.iconShow ? ['selected', 'option'] : [];
      if (typeof this.iconShow === "string") iconShow = this.iconShow.split(',');
      return iconShow.reduce((acc,curr) => (acc[curr.trim()]=true, acc), {});
    },
    _unitShow() {
      let unitShow = [];
      if (typeof this.unitShow === "boolean") unitShow = this.unitShow ? ['selected', 'option'] : [];
      if (typeof this.unitShow === "string") unitShow = this.unitShow.split(',');
      return unitShow.reduce((acc,curr) => (acc[curr.trim()]=true, acc), {});
    },
    _moreContentShow() {
      let moreContentShow = [];
      if (typeof this.moreContentShow === "boolean") moreContentShow = this.moreContentShow ? ['selected', 'option'] : [];
      if (typeof this.moreContentShow === "string") moreContentShow = this.moreContentShow.split(',');
      return moreContentShow.reduce((acc,curr) => (acc[curr.trim()]=true, acc), {});
    },
    _menuDrop() {
      return this.menuDrop || this.default.menuDrop;
    },

    
    optionSelected() {
      let option = this.getOption(this._selected);

      if (option !== undefined) return option;
      
      if (this._notMatchChange !== undefined) {
        let _option = this.getOption(this._notMatchChange);
        if (!_.isEqual(option, _option)) this.onChangeSelected(this.getValue(_option));
        return _option;
      }
      
      if (this._notMatchDefault !== undefined) {
        let _option = this.getOption(this._notMatchDefault);
        return _option;
      }

      return option;
    }
  },
  methods: {
    normalizedOptions(options) {
      let _options = {};

      if(options) {
        // Level1
        options.forEach(optionLv1 => {
          let _value1 = this.getValueNode(optionLv1);
          _options[_value1] = {
            ...optionLv1,
            _value: _value1,
            _level: '1',
            _disabled: Boolean(this._optionsDisabled.includes(_value1)),
          };
            
          // Level2
          const optionsLv2 = optionLv1.children || optionLv1.child || [];
          optionsLv2.forEach(optionLv2 => {
            let _value2 = _value1 + '-' + this.getValueNode(optionLv2);
            _options[_value2] = {
              ...optionLv2,
              _value: _value2,
              _level: '2',
              _disabled: Boolean(this._optionsDisabled.includes(_value2)),
            };

            // Level3
            const optionsLv3 = optionLv2.children || optionLv2.child || [];
            optionsLv3.forEach(optionLv3 => {
              let _value3 = _value2 + '-' + this.getValueNode(optionLv3);
              _options[_value3] = {
                ...optionLv3,
                _value: _value3,
                _level: '3',
                _disabled: Boolean(this._optionsDisabled.includes(_value3)),
              };

              // Level4
              const optionsLv4 = optionLv3.children || optionLv3.child || [];
              optionsLv4.forEach(optionLv4 => {
                let _value4 = _value3 + '-' + this.getValueNode(optionLv4);
                _options[_value4] = {
                  ...optionLv4,
                  _value: _value4,
                  _level: '4',
                  _disabled: Boolean(this._optionsDisabled.includes(_value4)),
                };
              });

            });

          });

        });
      }

      this.isEmpty = Boolean( Object.keys(_options).filter((key) => { return Boolean(key !== undefined && key !== null && key !== 'null' && key !== 'blank') }).length == 0 );

      return _options;
    },
    checkOptionsEmpty() {
      let optionExistsOnce = null;
      if (this.optionGroup) {
        this.options.forEach(optionGroup => {
          if (optionExistsOnce) return;
          optionExistsOnce = optionGroup.child.find((option) => {
            return option[this._optionValue] !== undefined && option[this._optionValue] !== null && option[this._optionValue] !== 'blank';
          });
        });

      } else {
        optionExistsOnce = this.options.find((option) => {
          return option[this._optionValue] !== undefined && option[this._optionValue] !== null && option[this._optionValue] !== 'blank';
        });
      }
      return optionExistsOnce ? false : true;
    },
    convertValueToString(value) {
      if (value && typeof value === 'object') { // {}
        if (Object.values(value).filter(Boolean).length == 0) {
          return null;
        } else {
          return Object.values(value).filter(Boolean).join("-"); // a-b-c-d
        }
      } else {
        return value;
      }
    },
    genValueFull(option1, option2 = null, option3 = null, option4 = null) {
      const optionID = {
        level1: option1 ? this.getValueNode(option1) : null, 
        level2: option2 ? this.getValueNode(option2) : null, 
        level3: option3 ? this.getValueNode(option3) : null, 
        level4: option4 ? this.getValueNode(option4) : null,
      }
      if (Object.values(optionID).filter(Boolean).length == 0) {
        return null;
      } else {
        return Object.values(optionID).filter(Boolean).join("-"); // aaa-bbb-ccc-ddd
      }
    },
    initIsSidebarArea() {
      const elemDropdown = this.$refs.dropdown.$el;
      const elemSidebar = elemDropdown.closest('.b-sidebar');
      this.isSidebarArea = Boolean(elemSidebar);
    },
    initDefaultMenuDrop() {
      if (this.isSidebarArea) this.default.menuDrop = 'right';
    },
    initDefaultMenuMaxWidth() {
      const elemDropdown = this.$refs.dropdown.$el;
      const elemSidebarBody = elemDropdown.closest('.overlay-body');
      const elemTabpane = elemDropdown.closest('.tab-pane');

      if (this.isSidebarArea) {
        const menu_gap_bound = 24;

        if (elemTabpane) {
          const tabpane_w = elemTabpane.offsetWidth;
          let menu_wx = tabpane_w - menu_gap_bound - menu_gap_bound;
          this.default.menuMaxWidth = `${menu_wx}px`;
        } else {
          const sidebarBody_w = elemSidebarBody.offsetWidth;
          let menu_wx = sidebarBody_w - menu_gap_bound - menu_gap_bound;
          this.default.menuMaxWidth = `${menu_wx}px`;
        }
      }
    },
    initDefaultMenuMaxHeight() {
      const elemDropdown = this.$refs.dropdown.$el;
      const elemSidebarBody = elemDropdown.closest('.overlay-body');
      const elemMenu = elemDropdown.querySelector('.dropdown-menu');

      if (this.isSidebarArea) {
        const menu_mt = parseInt(window.getComputedStyle(elemMenu).getPropertyValue('margin-top')); // 8
        const menu_mb = parseInt(window.getComputedStyle(elemMenu).getPropertyValue('margin-bottom')); // 8
        const menu_gap_bound = 24;

        // Downdown
        const sidebarBody_b = elemSidebarBody.getBoundingClientRect().bottom;
        const dropdown_b = elemDropdown.getBoundingClientRect().bottom;
        const menu_hx_ver_down = Math.abs(sidebarBody_b - dropdown_b) - menu_mt - menu_mb - menu_gap_bound;

        // Dropup
        const sidebarBody_t = elemSidebarBody.getBoundingClientRect().top;
        const dropdown_t = elemDropdown.getBoundingClientRect().top;
        const menu_hx_ver_up = Math.abs(sidebarBody_t - dropdown_t) - menu_mt - menu_mb - menu_gap_bound;

        let menu_hx = (menu_hx_ver_down > 150) ? menu_hx_ver_down : Math.max(menu_hx_ver_down, menu_hx_ver_up);
        this.default.menuMaxHeight = `${menu_hx}px`;
      }
    },

  
    // Option
    getOption(value) {
      let _value = value;
      if (_value && _value.split("-")[0] == '0') {
        _value = '0';
      }
      return this.rootOptions[_value];
    },
    getValue(option) { // a-b-c-d
      return option ? option._value : undefined;
    },
    getValueNode(option) { // d
      return option ? option[this._optionValue] : undefined;
    },
    getLabel(option) {
      return option ? option[this._optionLabel] : '';
    },
    getIcon(option) {
      return (option && this._optionIcon) ? option[this._optionIcon] : '';
    },
    getMoreContent(option) {
      let content = '';
      if (option === undefined) return content;
      if (this.conditions.length > 0) {
        this.conditions.forEach((condition) => {
          if (
            option[condition.key] == condition.matchValue || 
            (
              condition.key === this._optionDisabled && 
              condition.matchValue === true &&
              this._optionsDisabled.includes(this.getValue(option))
            )
          ) {
            content += condition.content;
          }
        });
      }
      return content;
    },
    isActive(value) {
      return Boolean(this.getValue(this.optionSelected) == value);
    },
    isDisabled(value) {
      const option = this.getOption(value);
      return Boolean(option && (
        (option[this._optionDisabled] !== undefined && option[this._optionDisabled]) || 
        option._disabled
      ));
    },

    // Render
    elemOptionClasses(level) {
      return { 
        [`dropdown-item-lv${level}`]: true,
      };
    },
    renderLabel(option) {
      return this.getLabel(option);
    },
    renderIcon(option) {
      return `<span class="d-inline-block mr-5" style="width: 16px;"><i class="${this.getIcon(option)}"></i></span>`;
    },
    renderUnit() {
      return `<span class="text-hint ml-3">${this.unit}</span>`;
    },
    renderSelectedTitle() {
      const option = this.optionSelected;
      if (option === undefined) return this._notMatchText;
      let label = "";
      label += this.getLabel(option); // label
      label += (this._unitShow.selected && this.unit) ? this.unit : ""; // unit
      return label;
    },
    renderSelectedContent() {
      const option = this.optionSelected;
      if (option === undefined) return this._notMatchText;
      let label = "";
      label += (this._iconShow.selected) ? this.renderIcon(option) : ""; // icon
      label += this.renderLabel(option); // label
      label += (this._unitShow.selected && this.unit) ? this.renderUnit() : ""; // unit
      label += (this.conditions.length > 0 && this._moreContentShow.selected) ? this.getMoreContent(option) : ""; // more content
      return label;
    },
    renderOptionContent(value) {
      const option = this.getOption(value);
      let label = "";
      label += (this._iconShow.option) ? this.renderIcon(option) : ""; // icon
      label += this.renderLabel(option); // label
      label += (this._unitShow.option && this.unit) ? this.renderUnit() : ""; // unit
      label += (this.conditions.length > 0 && this._moreContentShow.option) ? this.getMoreContent(option) : ""; // more content
      return label;
    },

    // Navigation
    navigate(text) {
      // reset hover
      const $elemHovered = this.$refs.dropdown.$el.querySelector('.dropdown-item.hover');
      if ($elemHovered) {
        $elemHovered.classList.remove('hover'); 
      }

      // find
      const $label = this.$refs.dropdown.$el.querySelector(`.dropdown-item .dropdown-item-label[title^="${text}"]`);
      if (!$label) return;

      const $elem = $label.closest('.dropdown-item');
      const $scrollbar = this.$refs.scrollbar.$el;

      $scrollbar.scrollTop = 0; // reset
      $scrollbar.scrollTop = $elem.getBoundingClientRect().top - $scrollbar.getBoundingClientRect().top; // goto
      $elem.classList.add('hover'); // hover
    },


    // Event
    onDropdownShow(bvEvent) {
      if (this.readonly === true || document.getElementById(bvEvent.componentId).hasAttribute('readonly')) { // For readonly + focus .dropdown-toggle when 
        bvEvent.preventDefault();
        document.getElementById(bvEvent.componentId).getElementsByClassName('dropdown-toggle')[0].focus();
      }

      if (this.isSidebarArea) {
        // Default MenuMaxWidth
        this.initDefaultMenuMaxWidth();

        // Default MenuMaxHeight
        this.initDefaultMenuMaxHeight();
      }
    },
    onDocKeyDown(e) {
      this.navigate(e.key.toUpperCase());
    },
    onChangeSelected(value) {
      this.$emit("change", value); // aaa-bbb-ccc-ddd
    },
  },
  mounted() {
    // Init IsSidebarArea
    this.initIsSidebarArea();

    // Default MenuDrop
    this.initDefaultMenuDrop();
    
    this.$refs.dropdown.$el.addEventListener('keydown', this.onDocKeyDown);
  },
  beforeDestroy() {
    this.$refs.dropdown.$el.removeEventListener('keydown', this.onDocKeyDown);
  },
  watch: {
    options: {
      handler() {
        this.rootOptions = this.normalizedOptions(this.options);
      },
      deep: true,
      immediate: true,
    },
    optionsDisabled(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) { // javascript don't know two arrays equal
        this.rootOptions = this.normalizedOptions(this.options); 
      }
    }
  }
};
</script>

<style>
/* MWE Tools - Treeselect 1.3 */
/* Menu */
.mwe-treeselect .dropdown-select.dropdown .dropdown-menu {
  max-width: var(--menu-max-width);
  overflow: hidden;
}
.mwe-treeselect .dropdown-menu-inner {
  overflow: auto;
  overscroll-behavior: none;
}
.mwe-treeselect .dropdown-menu-inner .dropdown-divider {
border-top: 1px solid #DEE3E6;
}
.mwe-treeselect .dropdown-menu .ps {
  height: auto;
  max-height: calc(var(--menu-max-height) - 8px - 8px);
}
</style>
